import * as helpers from "../helpers";
import * as Popup from "../components/Popup";
import validation from "jquery-validation";

$(document).ready(function (e) {
  if ($(document).find(".online-form").length > 0) {
    var dom = $(document).find(".online-form");

    //handle click events of upload form
    var uploadBtn = dom.find(".upload-button");

    // Manually inject required=required for SilverStripe fields that rely on the form
    // validator and ignore the field-specific attributes. Handle this by adding the
    // 'validate' attribute (eg $field->setAttribute('validate','required'))
    dom
      .find('[validate="required"]')
      .find("input")
      .attr("required", "required");

    var validator = $("form").validate({
      errorPlacement: function (error, element) {
        // Append error within linked label
        $(element)
          .closest("form")
          .find("label[for='" + element.attr("id") + "']")
          .closest(".field")
          .append(error);
      },
      errorElement: "div",
    });

    // Validation method to ensure a date input is over 16 years ago
    $.validator.addMethod(
      "sixteenYearsAgo",
      function (value, element) {
        var sixteenYearsAgo = new Date();
        sixteenYearsAgo.setFullYear(sixteenYearsAgo.getFullYear() - 16);
        sixteenYearsAgo.setDate(sixteenYearsAgo.getDate() + 1); // add one more day (accounts for birthday of today)

        // Convert human-friendly dd/mm/yyyy to js-friendly mm/dd/yyyy
        var inputDate_parts = value.split("/");
        var inputDate = new Date(
          inputDate_parts[2],
          inputDate_parts[1] - 1,
          inputDate_parts[0]
        ); // month is 0-based

        if (inputDate < sixteenYearsAgo) {
          return true;
        } else {
          return false;
        }
      },
      "Must be sixteen or over"
    );

    /**
     * Step navigation action
     *
     * Triggered by control buttons, only accessible via request to ensure
     * validation and autosaving is triggered first.
     **/
    var NavigateStep = function (current_step, next_step) {
      console.log("Step navigation: " + current_step + " to " + next_step);

      // get the steps as an object
      var origin_step_dom = $(".step:eq(" + current_step + ")");
      var destination_step_dom = $(".step:eq(" + next_step + ")");

      // animate the front-end
      origin_step_dom.fadeOut("fast", function (evt) {
        destination_step_dom.fadeIn("fast");
      });

      // update progress bar with new stats
      $(".progress__current-step").html(next_step + 1);
      $(".progress__bar__progress").css(
        "width",
        ((next_step + 1) / $(".step").length) * 100 + "%"
      );

      // And update our hidden field
      $('input[name="CurrentStep"]').val(next_step);

      // check new limits, and disable controls where applicable
      CheckStepLimits(next_step);
    };

    /**
     * Validate the current step's fields
     * Returns false if we need to halt the next step
     **/
    var ValidateStep = function () {
      var step = $(".step:eq(" + current_step + ")");
      var valid = true;

      // Run validation on all inputs in the current step
      step.find("input, select, textarea").each(function (i, element) {
        if (!validator.element(element)) {
          console.error("Validation failed for element", element);
          valid = false;
        }
      });

      return valid;
    };

    /**
     * Check the limits of the steps
     * Disables/changes buttons if applicable
     */
    var CheckStepLimits = function (destination) {
      if (destination == 0) {
        $(".step-controls .button.prev").hide();
        $(".step-controls .button.next").hide();
        $(".step-controls .button.start").show();
        $(".step-controls .button.save-for-confirmation").hide();
        $(".step-controls .button.complete-submission").hide();
        $(".step-controls .button.close").hide();
        $(".step-controls__left").hide();
      } else if (destination >= $(".step").length - 1) {
        $(".step-controls .button.start").hide();
        $(".step-controls .button.save-for-confirmation").show();
        $(".step-controls .button.complete-submission").hide();
        $(".save-or-cancel-buttons").addClass("hide");
        $(".step-controls .button.next").hide();
      } else if (destination > 0) {
        $(".step-controls .button.save-for-confirmation").hide();
        $(".step-controls .button.prev").show();
        $(".step-controls .button.next").show();
        $(".step-controls .button.start").hide();
        $(".step-controls .button.close").show();
        $(".step-controls__left").show();
      } else {
        $(".step-controls .button.save-for-confirmation").hide();
        $(".step-controls .button.save-for-confirmation").addClass("hide");
        $(".step-controls .button.complete-submission").addClass("hide");
        $(".step-controls .button.close").removeClass("hide");
      }
    };

    /**
     * Last saved UI
     *
     * Shows saving status, errors and how long since the last save for better debugging/support
     **/

    var last_saved = false;

    setInterval(updateLastSavedMessage, 10000);
    var updateLastSavedMessage = function () {
      if (last_saved) {
        var now = new Date().getTime();
        var difference = helpers.timeDifference(now, last_saved);
        $(document)
          .find(".autosave-status__last-saved__time")
          .attr("data-status", difference.status)
          .html(difference.content);
      }
    };

    /**
     * Autosave
     *
     * Periodically we save - provided some fields have changed and we're not already saving
     * This POSTs the entire form to the server and responds accordingly
     **/

    var autosaveStatus = $(document).find(".autosave-status");
    var save_in_progress = false;
    var last_autosave_data = dom.find("form").serialize();

    //push on empty checkboxes as serialize ignores
    $("form input[type=checkbox]").map(function () {
      if (!this.checked) {
        last_autosave_data = last_autosave_data + "&" + this.name + "=0";
      }
    });

    var autoSave = function () {
      // Construct our data
      var data = dom.find("form").serialize();
      //push on empty checkboxes as serialize ignores
      $("form input[type=checkbox]").map(function () {
        if (!this.checked) {
          data = data + "&" + this.name + "=0";
        }
      });

      // Detect if we've already saved this data
      // This helps prevent autosaving when nothing has changed
      if (data == last_autosave_data) {
        return;
      }

      // Prevent overlapped savings
      // AND only save if changes have been made
      if (save_in_progress) {
        console.log("Autosave already in progress");
        return;
      }

      // Spark it up
      save_in_progress = true;
      autosaveStatus
        .removeClass("autosave-status--error")
        .removeClass("autosave-status--saved")
        .addClass("autosave-status--saving");

      // post it off to the ContentController
      $.ajax({
        type: "POST",
        url: dom.attr("href").replace(/\/?$/, "/") + "save",
        data: data,
        timeout: 15000,
        success: function (response) {
          save_in_progress = false;
          last_autosave_data = data;

          last_saved = new Date().getTime();
          updateLastSavedMessage();
          autosaveStatus
            .removeClass("autosave-status--saving")
            .addClass("autosave-status--saved");

          // parse the returned ID and SecurityID into our form for future requests
          dom.find("input[name=SubmissionID]").val(response.SubmissionID);
          dom.find("input[name=SecurityID]").val(response.SecurityID);

          // get the ID for upload form
          var uploadFormUrl = uploadBtn.data("form");
          uploadBtn.attr(
            "data-id",
            uploadFormUrl.replace(/\/?$/, "/") + "edit/" + response.SubmissionID
          );

          console.log("Autosaved submission #" + response.SubmissionID);
        },
        error: function (error, textStatus, errorThrown) {
          save_in_progress = false;

          autosaveStatus
            .removeClass("autosave-status--saving")
            .addClass("autosave-status--error");

          if (error.responseJSON) {
            Popup.Create(
              error.responseJSON.MessageType,
              error.responseJSON.Message
            );
          } else if (textStatus == "timeout") {
            Popup.Create(
              "bad",
              "Timed out. Are you connected to the internet?"
            );
          } else {
            Popup.Create("bad", "Unknown error: " + error.statusText);
          }
        },
      });
    };

    // Only if we have a status (ie are in the wizard itself) should we setup autosaving
    // Attempt to save every 20 seconds
    if (autosaveStatus.length > 0) {
      var autosaveTimer = setInterval(autoSave, 5000);
    }

    /**
     * Step navigation request
     *
     * It is at this point we validate the whole step's fields using jquery-validate.
     * We also store the current step so resuming skips you to the most recent step.
     **/

    // count total
    $(".progress__total-steps").html($(".step").length);
    $(".progress__bar__progress").css(
      "width",
      (1 / $(".step").length) * 100 + "%"
    );

    var current_step = -1;
    var next_step = 0;

    // URL-based step definition
    // Usually only used when redirected back from the confirmation window
    var hash = window.location.hash.replace("#", "");
    if (hash && hash.indexOf("step-") == 0) {
      next_step = parseInt(hash.replace("step-", ""));
      current_step = next_step;

      // Form field-based step navigation
      // This is usually the case when resuming a form. It enables us to
      // jump to the last saved position.
    } else if ($('input[name="CurrentStep"]').val() > 0) {
      var restored_step = parseInt($('input[name="CurrentStep"]').val());
      next_step = restored_step;
      current_step = restored_step;

      // No initial default, so navigate to the first step
    } else {
      next_step = current_step + 1;
      current_step = next_step;
    }

    // And now navigate to our initial step
    NavigateStep(current_step, next_step);

    // control button click
    $(".step-controls .navigation-control.button").on("click", function (evt) {
      if ($(this).hasClass("next") || $(this).hasClass("start")) {
        if (ValidateStep()) {
          // NavigateStep(current_step, current_step+1);
          // current_step++;
          //add UML into this logic
          if (
            $("input[type=radio][name=PropertyTypeOptions]:checked").val() ==
              "Distributed Generation" &&
            current_step == 1
          ) {
            //if we are on the PropertyTypeOptions step and the value is DG then we skip a step
            NavigateStep(current_step, current_step + 2);
            current_step = current_step + 2;
          } else if (
            $("input[type=radio][name=PropertyTypeOptions]:checked").val() ==
              "Unmetered Load" && current_step == 1
          ) {
            //if we are on the PropertyTypeOptions step and the value is UL then we skip a step
            NavigateStep(current_step, current_step + 2);
            current_step = current_step + 2;
          } else {
            NavigateStep(current_step, current_step + 1);
            current_step++;
          }
        }
      } else if ($(this).hasClass("prev")) {
        // NavigateStep(current_step, current_step - 1);
        // current_step--;
        if (
          $("input[type=radio][name=PropertyTypeOptions]:checked").val() ==
            "Distributed Generation" &&
          current_step == 3
        ) {
          //if we are on the jobsize step and the value is DG then we skip a step
          NavigateStep(current_step, current_step - 2);
          current_step = current_step - 2;
        } else if (
          $("input[type=radio][name=PropertyTypeOptions]:checked").val() ==
            "Unmetered Load" &&
          current_step == 3
        ) {
          //if we are on the jobsize step and the value is UL then we skip a step
          NavigateStep(current_step, current_step - 2);
          current_step = current_step - 2;
        } else {
          NavigateStep(current_step, current_step - 1);
          current_step--;
        }
      }
    });

    /**
     * tool tips
     */
    dom.find(".tooltip-btn").on("click", function (event) {
      var tooltip = $(this).data("popup");
      $("." + tooltip).show();
    });

    $(document).click(function (e) {
      if (
        !$(e.target).hasClass("tooltip-btn") &&
        $(e.target).parents(".tooltip__wrapper").length === 0
      ) {
        $(".tooltip__wrapper").hide();
      }
    });

    /**
     * Save for later
     *
     * POSTs form to server and redirects to a confirmation page. This also sends
     * emails to the user (handled by server).
     **/

    dom
      .find(".save-for-later, .save-for-confirmation")
      .on("click", function (event) {
        event.preventDefault();

        if (ValidateStep()) {
          // Stop any overlapping auto-saves
          // This helps prevent a 'draft' being created while we're submitting (because
          // submitting takes longer than saving)
          save_in_progress = true;

          var data = dom.find("form").serializeArray();

          //push on empty checkboxes as serialize ignores
          $("form input[type=checkbox]").map(function () {
            if (!this.checked) {
              data.push({ name: this.name, value: "0" });
            }
          });

          if ($(this).hasClass("save-for-later")) {
            data.push({ name: "SaveForLater", value: true });
          } else if ($(this).hasClass("save-for-confirmation")) {
            data.push({ name: "SaveForConfirmation", value: true });
          }

          var button = $(this);
          var loader = $(document).find(".loader--full-screen");
          loader.show();

          // post it off to the ContentController
          $.ajax({
            type: "POST",
            url: dom.attr("href").replace(/\/?$/, "/") + "save",
            data: data,
            timeout: 30000,
            success: function (response) {
              save_in_progress = false;
              loader.fadeOut("fast");
              if (response.Redirect) {
                window.location = response.Redirect;
              }
            },
            error: function (error, textStatus, errorThrown) {
              save_in_progress = false;
              loader.fadeOut("fast");

              if (error.responseJSON) {
                Popup.Create(
                  error.responseJSON.MessageType,
                  error.responseJSON.Message
                );
              } else if (textStatus == "timeout") {
                Popup.Create(
                  "bad",
                  "Timed out. Are you connected to the internet?"
                );
              } else {
                Popup.Create("bad", "Unknown error: " + error.statusText);
              }
            },
          });
        }
      });

    /**
     * Submit
     *
     * POST all data to server for final submission. This triggers the generation
     * of PDFs and email notifications (all handled server-side)
     **/
    dom.find(".complete-submission").on("click", function (e) {
      e.preventDefault();

      if (ValidateStep()) {
        // Stop any overlapping auto-saves
        // This helps prevent a 'draft' being created while we're submitting (because
        // submitting takes longer than saving)
        save_in_progress = true;

        var data = dom.find("form").serializeArray();
        //push on empty checkboxes as serialize ignores
        $("form input[type=checkbox]").map(function () {
          if (!this.checked) {
            data.push({ name: this.name, value: "0" });
          }
        });
        var button = $(this);

        var loader = $(document).find(".loader--full-screen");
        loader.show();

        // post it off to the ContentController
        $.ajax({
          type: "POST",
          url: dom.attr("href").replace(/\/?$/, "/") + "complete",
          data: data,
          timeout: 30000,
          success: function (response) {
            save_in_progress = false;
            loader.fadeOut("fast");
            if (response.Redirect) {
              window.location = response.Redirect;
            }
          },
          error: function (error, textStatus, errorThrown) {
            save_in_progress = false;
            loader.fadeOut("fast");

            if (error.responseJSON) {
              Popup.Create(
                error.responseJSON.MessageType,
                error.responseJSON.Message
              );
            } else if (textStatus == "timeout") {
              Popup.Create(
                "bad",
                "Timed out. Are you connected to the internet?"
              );
            } else {
              Popup.Create("bad", "Unknown error: " + error.statusText);
            }
          },
        });
      }
    });
  }
});
